import { render, staticRenderFns } from "./addScoreItem.vue?vue&type=template&id=fde3c270&scoped=true&"
import script from "./addScoreItem.vue?vue&type=script&lang=js&"
export * from "./addScoreItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde3c270",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fde3c270')) {
      api.createRecord('fde3c270', component.options)
    } else {
      api.reload('fde3c270', component.options)
    }
    module.hot.accept("./addScoreItem.vue?vue&type=template&id=fde3c270&scoped=true&", function () {
      api.rerender('fde3c270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/divisionAllController/component/addScoreItem.vue"
export default component.exports